import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useLearningItem } from "../hooks/use-learning-item.js";
import LearningItemLayout from "./learning-item-layout.js";
import MarkAsDone from "./mark-as-done.js";
import useAutoCompleteOnView from "../hooks/use-auto-complete-on-view.js";
import useShouldShowMarkAsDone from "../hooks/use-should-show-mark-as-done.js";

export default function LearningItemView() {
  const { currentModuleItemId, currentModuleItemTitle, isCurrentOptional, nextItem, nextItemLink, isCurrentCompleted } =
    useLearningItem();
  const shouldShowMarkAsDone = useShouldShowMarkAsDone();
  useAutoCompleteOnView();

  // Reset scroll position whenever the user lands on a different learning item
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [currentModuleItemId]);

  return (
    <LearningItemLayout
      title={currentModuleItemTitle}
      isOptional={isCurrentOptional}
      footerActions={shouldShowMarkAsDone ? <MarkAsDone /> : undefined}
      nextItem={nextItem}
      nextItemLink={nextItemLink}
      isCurrentCompleted={isCurrentCompleted}>
      <Outlet />
    </LearningItemLayout>
  );
}
